import { useState } from "react";
import { Button, Icon } from "semantic-ui-react";

import { Can } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import "modules/ChecklistSettingsDashboard/components/ChecklistSettingsHeader/ChecklistSettingsHeader.scss";
import { useReportTemplatesQuery } from "modules/ChecklistSettingsDashboard/components/ChecklistTemplatesTable/hooks";
import { TemplateModal } from "modules/ChecklistSettingsDashboard/components/TemplateModal";

export const ChecklistSettingsHeader = () => {
  const [isCreateTemplateModalOpen, setIsCreateTemplateModalOpen] = useState(false);

  const { data: reportTemplateOptions = [] } = useReportTemplatesQuery();

  return (
    <>
      <Can I={ACL_ACTIVITIES.Create} the={ACL_RESOURCES.ChecklistTemplates}>
        <div className="ChecklistSettingsHeader">
          <Button basic icon className="add-btn" onClick={() => setIsCreateTemplateModalOpen(true)}>
            <Icon className="plus" />
          </Button>
        </div>
      </Can>
      <TemplateModal
        templateID={null}
        isOpen={isCreateTemplateModalOpen}
        reportTemplateOptions={reportTemplateOptions}
        onClose={() => setIsCreateTemplateModalOpen(false)}
      />
    </>
  );
};
